module.exports = __webpack_public_path__ + "img/memory_details.05e4403b.png";